module.exports = require("addons-scanner-utils/errors");